<template>
  <div class="layout px-0">
    <v-btn icon class="mx-0">
      <v-icon color="teal" @click="setData()">edit</v-icon>
    </v-btn>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  data: () => ({}),
  methods: {
    setData() {
      this.params.clicked(this.params.data);
    },
  },
});
</script>